'use strict';
import * as $j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId from "./app.data.-Immu-D-B-Data-Center-Id.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ImmuDBDataCenterId$$anon$1(\u03b4name$2, _$ordinal$2) {
  this.ahF = null;
  this.ahG = 0;
  this.ahF = \u03b4name$2;
  this.ahG = _$ordinal$2;
}
export { $c_Lapp_data_ImmuDBDataCenterId$$anon$1 as $c_Lapp_data_ImmuDBDataCenterId$$anon$1 };
$p = $c_Lapp_data_ImmuDBDataCenterId$$anon$1.prototype = new $j_app$002edata$002e$002dImmu$002dD$002dB$002dData$002dCenter$002dId.$h_Lapp_data_ImmuDBDataCenterId();
$p.constructor = $c_Lapp_data_ImmuDBDataCenterId$$anon$1;
/** @constructor */
function $h_Lapp_data_ImmuDBDataCenterId$$anon$1() {
}
export { $h_Lapp_data_ImmuDBDataCenterId$$anon$1 as $h_Lapp_data_ImmuDBDataCenterId$$anon$1 };
$h_Lapp_data_ImmuDBDataCenterId$$anon$1.prototype = $p;
$p.s = (function() {
  return 0;
});
$p.e = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.u = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElementName__I__T(this, n);
});
$p.t = (function() {
  return this.ahF;
});
$p.n = (function() {
  return this.ahF;
});
$p.co = (function() {
  return this.ahG;
});
$p.U = (function(p) {
  return this;
});
var $d_Lapp_data_ImmuDBDataCenterId$$anon$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ImmuDBDataCenterId$$anon$1, "app.data.ImmuDBDataCenterId$$anon$1", ({
  DO: 1,
  jB: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  r: 1,
  d: 1,
  e: 1,
  k: 1
}));
export { $d_Lapp_data_ImmuDBDataCenterId$$anon$1 as $d_Lapp_data_ImmuDBDataCenterId$$anon$1 };
//# sourceMappingURL=app.data.-Immu-D-B-Data-Center-Id$$anon$1.js.map
